import { Component } from '@angular/core';
import { BaseSectionComponent } from '../base-section.component';
import { AssetPipe } from '../../../../../../../../pipes/asset.pipe';

@Component({
    selector: 'app-section-teacher-information',
    templateUrl: './section-teacher-information.component.html',
    styleUrls: ['./section-teacher-information.component.scss'],
    imports: [
        AssetPipe
    ],
    standalone: true
})
export class SectionTeacherInformationComponent extends BaseSectionComponent {

}